var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"shell-system-loading-wrapper",class:{ 'hide-menu': _vm.hideLayout.menu }},[_c('div',{staticClass:"shell-system-loading"},_vm._l((12),function(index){return _c('div',{key:index})}),0)])}
var staticRenderFns = []

export { render, staticRenderFns }